import React, { useState } from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsModal } from './TermsModal';
import { FAQModal } from './FAQModal';
import { useNavigate } from 'react-router-dom';
export function Footer() {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isFAQModalOpen, setIsFAQModalOpen] = useState(false);
  const navigate = useNavigate();
  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-black border-t border-yellow-600/20 py-12 px-6" data-id="element-36">
      <div className="max-w-6xl mx-auto" data-id="element-37">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-38">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-39">
            <div className="text-2xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent mb-4" data-id="element-40">
              SAMBOCARD
            </div>
            <p className="text-gray-400 text-sm" data-id="element-41">
              Tu tarjeta de beneficios gratuita con descuentos y promociones en
              cientos de lugares.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-42">
            <h4 className="text-white font-bold mb-4" data-id="element-43">Enlaces Rápidos</h4>
            <ul className="space-y-2 text-gray-400 text-sm" data-id="element-44">
              <li data-id="element-45">
                <a href="/" onClick={handleHomeClick} className="hover:text-yellow-400 transition-colors" data-id="element-46">
                  Inicio
                </a>
              </li>
              <li data-id="element-47">
                <button onClick={() => setIsFAQModalOpen(true)} className="hover:text-yellow-400 transition-colors text-left" data-id="element-48">
                  Preguntas Frecuentes
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-49">
            <h4 className="text-white font-bold mb-4" data-id="element-50">Legal</h4>
            <ul className="space-y-2 text-gray-400 text-sm" data-id="element-51">
              <li data-id="element-52">
                <button onClick={() => setIsTermsModalOpen(true)} className="hover:text-yellow-400 transition-colors text-left" data-id="element-53">
                  Términos y Condiciones
                </button>
              </li>
              <li data-id="element-54">
                <button onClick={() => setIsPrivacyModalOpen(true)} className="hover:text-yellow-400 transition-colors text-left" data-id="element-55">
                  Política de Privacidad y Protección de Datos
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-56">
            <h4 className="text-white font-bold mb-4" data-id="element-57">Contacto</h4>
            <ul className="space-y-3 text-gray-400 text-sm" data-id="element-58">
              <li className="flex items-start gap-2" data-id="element-59">
                <MailIcon className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" data-id="element-60" />
                <span data-id="element-61">contacto@sambocard.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Social & Copyright */}
        <div className="border-t border-yellow-600/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-62">
          <div className="text-gray-400 text-sm" data-id="element-63">
            © 2025 SamboCard es una marca de PromRed. Todos los derechos
            reservados.
          </div>

          <div className="flex gap-4" data-id="element-64">
            <a href="https://www.instagram.com/sambocard" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-gray-800 rounded-full hover:bg-yellow-600 transition-colors group" data-id="element-65">
              <InstagramIcon className="w-5 h-5 text-gray-400 group-hover:text-black" data-id="element-66" />
              <span className="text-gray-400 group-hover:text-black text-sm font-medium" data-id="element-67">
                @sambocard
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} data-id="element-68" />

      {/* Terms Modal */}
      <TermsModal isOpen={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)} data-id="element-69" />

      {/* FAQ Modal */}
      <FAQModal isOpen={isFAQModalOpen} onClose={() => setIsFAQModalOpen(false)} data-id="element-70" />
    </footer>;
}